(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["okd-section-design"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('okd-custom-panel')) {
  customElements.define('okd-custom-panel', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.querySelectorAll('[data-okdx-tilt="true"]').forEach(card => {
        const reset = () => ['--rx','--ry','--lift'].forEach(k => card.style.removeProperty(k));
        const move = e => {
          if (reduced.matches || e.target.closest('video')) return;
          const r = card.getBoundingClientRect();
          card.style.setProperty('--rx', `${(0.5-Math.max(0,Math.min(1,(e.clientY-r.top)/r.height)))*4}deg`);
          card.style.setProperty('--ry', `${(Math.max(0,Math.min(1,(e.clientX-r.left)/r.width))-0.5)*4}deg`);
          card.style.setProperty('--lift','-2px');
        };
        ['pointermove','pointerdown'].forEach(type => card.addEventListener(type,move,{signal,passive:true}));
        ['pointerleave','pointerup','pointercancel'].forEach(type => card.addEventListener(type,reset,{signal,passive:true}));
        reduced.addEventListener('change',reset,{signal});
      });
      const details = [...this.querySelectorAll('.okdx-faq-list > details')];
      const enforce = chosen => { if (this.dataset.multiple === 'false') details.forEach(d => {if(d!==chosen)d.open=false;}); };
      details.forEach(d => d.addEventListener('toggle',()=>{if(d.open)enforce(d);},{signal}));
      document.addEventListener('shopify:block:select',e=>{const d=e.target.closest('details');if(d&&this.contains(d)){enforce(d);d.open=true;}},{signal});
      const auto = [...this.querySelectorAll('[data-okdx-autoplay]')].map(e=>e.parentElement.querySelector('video')).filter(Boolean);
      const visible = new WeakSet(), manual = new WeakSet();
      const sync = () => auto.forEach(v=>{if(document.hidden||reduced.matches||!visible.has(v))v.pause();else if(!manual.has(v)){v.muted=true;v.play().catch(()=>{});}});
      auto.forEach(v=>['pointerdown','keydown'].forEach(type=>v.addEventListener(type,()=>manual.add(v),{signal,passive:true})));
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries=>{entries.forEach(e=>e.isIntersecting&&e.intersectionRatio>=.25?visible.add(e.target):visible.delete(e.target));sync();},{threshold:[0,.25]});
        auto.forEach(v=>this.observer.observe(v));
      }
      reduced.addEventListener('change',sync,{signal});
      document.addEventListener('visibilitychange',sync,{signal});
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.querySelectorAll('video').forEach(v=>v.pause());
      this.abort?.abort();
      this.abort=null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
